import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export type DateFormatType = 'MM-dd-yyyy' | 'dd/MM/yyyy';

@Injectable()
export class CustomDateFormatter extends NgbDateParserFormatter {
  readonly DELIMITER = '-';
  dateFormat: DateFormatType = 'MM-dd-yyyy';

  parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    if (this.dateFormat === 'dd/MM/yyyy') {
      return this.parseDdMmYyyy(value.trim());
    }

    const date = value.split(this.DELIMITER);
    if (date.length === 3 && date[0].length === 4) {
      return {
        day: parseInt(date[2], 10),
        month: parseInt(date[1], 10),
        year: parseInt(date[0], 10)
      };
    }

    return {
      day: parseInt(date[1], 10),
      month: parseInt(date[0], 10),
      year: parseInt(date[2], 10)
    };
  }

  format(date: NgbDateStruct | null): string {
    if (!date) {
      return '';
    }

    if (this.dateFormat === 'dd/MM/yyyy') {
      return `${this.pad(date.day)}/${this.pad(date.month)}/${date.year}`;
    }

    return `${this.pad(date.month)}${this.DELIMITER}${this.pad(date.day)}${this.DELIMITER}${date.year}`;
  }

  private parseDdMmYyyy(value: string): NgbDateStruct | null {
    if (/^\d{8}$/.test(value)) {
      return {
        day: parseInt(value.substring(0, 2), 10),
        month: parseInt(value.substring(2, 4), 10),
        year: parseInt(value.substring(4, 8), 10)
      };
    }

    if (/[-/]/.test(value)) {
      const date = value.split(/[-/]/);
      if (date.length === 3 && date[0].length === 4) {
        return {
          day: parseInt(date[2], 10),
          month: parseInt(date[1], 10),
          year: parseInt(date[0], 10)
        };
      }

      if (date.length === 3 && date[2].length === 4) {
        const first = parseInt(date[0], 10);
        const second = parseInt(date[1], 10);

        if (first > 12) {
          return { day: first, month: second, year: parseInt(date[2], 10) };
        }

        if (second > 12) {
          return { day: second, month: first, year: parseInt(date[2], 10) };
        }

        return { day: first, month: second, year: parseInt(date[2], 10) };
      }
    }

    return null;
  }

  private pad(value: number): string {
    if (value === 0 || value === null || value === undefined) {
      return '00';
    }
    return value.toString().padStart(2, '0');
  }
}
